import React from "react";
import { Link } from "react-router-dom";
import { ErrorBoundary } from "../errorHandling/errorBoundary.jsx";
//import GBETHelper from "../gbetutils.js";

class Leftnav extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoggedIn: false,
            displayEvents: [],
            topEventClassifierId: 1,
            currentEventClassifier: null,
            isBodyVisible: true,
            clickedEventClassifierId: null,
            activeEventGrouping: null,
            isVirtual: false,
            todaysEvents: [],
            allEvents: []
        };

        this.thisComponentRef = React.createRef();
        this.virtualsConfig = GBEglobal.settings.virtualConfig;
        this.renderChildrenEvents = this.renderChildrenEvents.bind(this);
        this.renderParentEvents = this.renderParentEvents.bind(this);
        this.renderCurrentEvent = this.renderCurrentEvent.bind(this);
        this.getEventGroupingMarketTypes = this.getEventGroupingMarketTypes.bind(this);
        this.checkHash = this.checkHash.bind(this);

        this.hideEventClassifiers = [];

        if (GBEglobal.mode === ModeTypes.Singles) {
            if (GBEglobal.settings["exchange.HideEventClassifier"] && GBEglobal.settings["exchange.HideEventClassifier"].ids && GBEglobal.settings["exchange.HideEventClassifier"].ids.length > 0) {
                this.hideEventClassifiers = GBEglobal.settings["exchange.HideEventClassifier"].ids;
            }
        } else if (GBEglobal.mode === ModeTypes.Sportsbook) {
            if (GBEglobal.settings["sportsbook.HideEventClassifier"] && GBEglobal.settings["sportsbook.HideEventClassifier"].ids && GBEglobal.settings["sportsbook.HideEventClassifier"].ids.length > 0) {
                this.hideEventClassifiers = GBEglobal.settings["sportsbook.HideEventClassifier"].ids;
            }
        }
    }

    componentDidMount() {
        this.unregisterHistoryListener = this.props.history.listen(() => {

            this.checkHash();
        });

        this.checkHash();
    }

    componentWillUnmount() {
        this.unregisterHistoryListener();
    }

    checkHash() {
        const thisComponent = this;

        var parts = window.location.hash.split("=");
        switch (parts[0]) {
            case "#filter":
                var hashParts = parts[1].split("-");

                var filterEvents = [hashParts[0]]; // array with just eventId

                if (GBEglobal.todaysEvents[hashParts[0]][hashParts[1]].filterEvents.length > 0) {
                    filterEvents = GBEglobal.todaysEvents[hashParts[0]][hashParts[1]].filterEvents;
                }

                fetch(configurationSettings.baseUrl + "api/navigation.ashx", {
                    method: "POST",
                    headers: {
                        "Accept": "application/json",
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify({ filterEvents: filterEvents, eventId: hashParts[0] })
                }).then(function (response) {
                    // The API call was successful!
                    if (response.ok) {
                        return response.json();
                    }
                }).then(function (navigation) {


                    //if (navigation.todaysEvents) {
                    thisComponent.setState({
                        todaysEvents: navigation.todaysEvents
                    });
                    // }

                }).catch(function (err) {
                    // There was an error
                    console.warn("Something went wrong getting navigation events: ", err);
                });

                break;
        }

    }

    renderParentEvents(eventClassifier) {
        const thisComponent = this;

        if (eventClassifier === null || eventClassifier === undefined) {
            return null;
        }
        function getClasses(eventClassifier) {
            return "sport_icon generic _" + eventClassifier.eventClassifierId;
        }
        var parentEvents = [];
        var eventIdIndex = {};
        var alleventsid;

        const parts = window.location.hash.split("=");
        if (parts[0] === "#filter") {
            var hashParts = parts[1].split("-");
            alleventsid = Number(hashParts[0]);
            eventIdIndex[hashParts[0]] = true;

        }

        var parentEvent = eventClassifier.getParent();
        while (parentEvent !== undefined && parentEvent !== null && parentEvent !== [] && parentEvent.eventClassifierName !== "root") {

            if (!GBEUtils.isDescendantOf(parentEvent, eventIdIndex) || alleventsid === parentEvent.eventClassifierId) {
                parentEvents.splice(0, 0, parentEvent);
            }

            parentEvent = parentEvent.getParent();
        }

        if (parentEvents.length === 0 || thisComponent.state.isVirtual) {
            return null;
        }

        return (
            <ErrorBoundary componentName="renderParentEvents">
                <div>
                    {parentEvents.map((eventClassifier, index) => {
                        return (
                            <Link className="btn btn-default parentEvent current" key={index} to={GBEglobal.getEventClassifierPath(eventClassifier)} onClick={this.handleEventClick.bind(this, eventClassifier)}>
                                <i className={getClasses(eventClassifier)}>sports_soccer</i> {eventClassifier.eventClassifierName}
                            </Link>
                        );
                    })}
                </div>
            </ErrorBoundary>
        );

    }

    renderCurrentEvent(eventClassifier) {
        const thisComponent = this;
        if (eventClassifier === null || eventClassifier === undefined || thisComponent.state.isVirtual || eventClassifier.getChildren().length === 0) {
            return null;
        }
        function getClasses(eventClassifier) {
            return "sport_icon generic _" + eventClassifier.eventClassifierId;
        }

        return (
            <Link className="btn btn-default current" to={GBEglobal.getEventClassifierPath(eventClassifier)} onClick={this.handleEventClick.bind(this, eventClassifier)}>
                <i className={getClasses(eventClassifier)}>sports_soccer</i> {eventClassifier.eventClassifierName}
            </Link>
        );
    }

    renderChildrenEvents(eventClassifier) {
        const thisComponent = this;

        function getClasses(thisEvent) {
            var ev = eventClassifier || thisEvent || {};

            return "sport_icon generic _" + ev.eventClassifierId;
        }
        const isVirtual = eventClassifier && eventClassifier.eventClassifierName.toLocaleLowerCase().indexOf("virtual") !== -1 ? true : false;

        if ((eventClassifier === null || eventClassifier === undefined && !thisComponent.state.isVirtual) || isVirtual) {
            let finalEventClassifiers = [];
            if (this.hideEventClassifiers.length > 0) {
                this.props.eventClassifiers.forEach((ev) => {
                    const hideEvent = thisComponent.hideEventClassifiers.indexOf(ev.eventClassifierId);
                    if (hideEvent === -1) {
                        finalEventClassifiers.push(ev);
                    }
                });
            } else {
                finalEventClassifiers = this.props.eventClassifiers;
            }

            return (
                <div>
                    {finalEventClassifiers.map((eventClassifierInner, index) => {
                        let topClass = "btn btn-default top a";
                        if (thisComponent.state.clickedEventClassifierId !== null && thisComponent.state.clickedEventClassifierId === eventClassifierInner.eventClassifierId) {
                            topClass += " current";
                        }
                        return (
                            <Link className={topClass} key={index} to={GBEglobal.getEventClassifierPath(eventClassifierInner)} onClick={this.handleEventClick.bind(this, eventClassifierInner)}>
                                <i className={getClasses(eventClassifierInner)}>sports_soccer</i> {eventClassifierInner.eventClassifierName}
                            </Link>
                        );
                    })}
                </div>
            );
        }
        var childEvents = eventClassifier.getChildren();
        const parentEvent = eventClassifier.getParent();
        if ((parentEvent !== undefined && parentEvent !== null) && childEvents.length === 0) {
            childEvents = parentEvent.getChildren();
        }
        if (childEvents === undefined || childEvents.length === 0) {
            return null;
        }
        const classNames = "sport_icon _" + eventClassifier.eventClassifierId;

        const finalChildEvents = [];
        childEvents.forEach((ev) => {
            const hasInplayChild = ev.getMarkets().length > 0 ? ev.getMarkets().filter((o) => o.currentlyInRunning).length > 0 : false;
            const removeInplayChild = GBEglobal.mode === ModeTypes.Multiples && hasInplayChild;
            if (this.hideEventClassifiers.length > 0) {
                const hideEvent = thisComponent.hideEventClassifiers.indexOf(ev.eventClassifierId);
                if (hideEvent === -1 && !removeInplayChild) {
                    finalChildEvents.push(ev);
                }
            } else {
                if (!removeInplayChild) {
                    finalChildEvents.push(ev);
                }
            }
        });

        const marketTypes = thisComponent.getEventGroupingMarketTypes(eventClassifier);

        function getGroupMarkets(eventClassifier, marketTypeId) {
            thisComponent.props.getGroupMarkets(eventClassifier, marketTypeId);
            thisComponent.setState({
                activeEventGrouping: marketTypeId,
                clickedEventClassifierId: null
            });
        }

        return (
            <div>
                {marketTypes !== undefined &&
                    marketTypes.map((marketType) => {
                        var marketTypeParent = eventClassifier.getChildren().length ? eventClassifier : eventClassifier.getParent();
                        const activeEventGrouping = marketType.marketTypeId === thisComponent.state.activeEventGrouping ? " current" : "";
                        return marketType.showGroupedMarkets ? <Link to={GBEglobal.getEventClassifierPath(marketTypeParent) + "#marketTypes=" + marketTypeParent.eventClassifierId + "," + marketType.marketTypeId} key={GBEUtils.createUUID()} onClick={() => getGroupMarkets(marketTypeParent, marketType.marketTypeId)} className={"btn btn-default children b" + activeEventGrouping}>{marketType.marketTypeTitle}</Link> : "";
                    })
                }
                {finalChildEvents.map((eventClassifier, index) => {
                    let childrenClass = "btn btn-default children b";
                    if (thisComponent.state.clickedEventClassifierId !== null && thisComponent.state.clickedEventClassifierId === eventClassifier.eventClassifierId) {
                        childrenClass += " current";
                    }
                    return (
                        <Link className={childrenClass} key={index} to={GBEglobal.getEventClassifierPath(eventClassifier)} onClick={this.handleEventClick.bind(this, eventClassifier)}>
                            <i className={classNames}>sports_soccer</i> {eventClassifier.eventClassifierName}
                        </Link>
                    );
                })
                }
            </div>
        );
    }

    handleEventClick(eventClassifier) {

        //const thisComponent = this;

        var navigationEventId = (eventClassifier !== null) ? eventClassifier.eventClassifierId : 1;
        fetch(configurationSettings.baseUrl + "api/navigation.ashx", {
            method: "POST",
            headers: {
                "Accept": "application/json",
                "Content-Type": "application/json"
            },
            body: JSON.stringify({ filterEvents: [], eventId: navigationEventId })
        }).then(function (response) {
            // The API call was successful!
            if (response.ok) {
                return response.json();
            }
        }).then(function () {
            //thisComponent.setState({
            //    todaysEvents: navigation.todaysEvents
            //});
        }).catch(function (err) {
            // There was an error
            console.warn("Something went wrong getting navigation events: ", err);
        });


        GBEglobal.logger.log({ hitType: "event", eventCategory: "left-nav", eventAction: "click", eventLabel: eventClassifier !== null ? eventClassifier.eventClassifierName.toLowerCase().replace(/\s/g, "-") + "-category" : "all-markets-category" });
        var thisleftNav = this;

        const isVirtual = eventClassifier && this.virtualsConfig && eventClassifier.eventClassifierId === this.virtualsConfig.virtuals;
        if ((eventClassifier === null || eventClassifier === undefined || eventClassifier.getChildren().length > 0) && !isVirtual) {

            thisleftNav.setState({
                currentEventClassifier: eventClassifier
            });
            this.thisComponentRef.current.scrollTop = 0;
        }
        if (eventClassifier === null || eventClassifier === undefined) {
            thisleftNav.props.onAllSportsClicked();
        }
        thisleftNav.setState({
            clickedEventClassifierId: (eventClassifier !== null) && (eventClassifier !== undefined) ? eventClassifier.eventClassifierId : null,
            isVirtual: isVirtual,
            activeEventGrouping: null
        }, () => {
            if (thisleftNav.props.onEventSelected !== undefined) {
                thisleftNav.props.onEventSelected(eventClassifier);
            }
        });

        if (configurationSettings.whiteLabel.toLocaleLowerCase() === "betdaq" && !thisleftNav.props.isAnchorPage && document.getElementById("container").classList.contains("leftPanelToggled")) {
            thisleftNav.props.togglePanel(false);
        }

    }

    handleHeaderClick() {
        GBEglobal.logger.log({ hitType: "event", eventCategory: "left-nav", eventAction: "click", eventLabel: "sports-header" });
        this.setState({
            isBodyVisible: !this.state.isBodyVisible
        });
    }

    static getDerivedStateFromProps(newProps, state) {
        if (state.currentEventClassifier !== newProps.activeEventClassifier) {
            const clickedEventClassifierId = newProps.activeEventClassifier === undefined ? null : state.clickedEventClassifierId;

            var currentEventClassifier = null;
            if (newProps.activeEventClassifier !== undefined) {
                currentEventClassifier = newProps.controller.getCachedEventClassifier(newProps.activeEventClassifier.eventClassifierId);
            }
            const isVirtual = currentEventClassifier && GBEglobal.settings.virtualConfig && GBEUtils.getTopLevelEvent(currentEventClassifier).eventClassifierId === GBEglobal.settings.virtualConfig.virtuals;

            return {
                isVirtual: isVirtual,
                currentEventClassifier: currentEventClassifier,
                clickedEventClassifierId: newProps.activeEventClassifier !== undefined ? newProps.activeEventClassifier.eventClassifierId : clickedEventClassifierId
            };
        }
        return null;
    }

    getEventGroupingMarketTypes(currentEventClassifier) {

        if (currentEventClassifier) {
            const groupMarketsKey = String.format("gEP.{0}-{1}-Web.GroupMarkets", GBEglobal.mode === ModeTypes.Sportsbook ? "Sportsbook" : "Exchange", configurationSettings.whiteLabel.toUpperCase());
            const groupMarketsGTV = GBEglobal.settings[groupMarketsKey] || [];
            const activeEventClassifierId = currentEventClassifier.eventClassifierId;
            const parent = currentEventClassifier.getParent();
            let events = currentEventClassifier.getChildren();

            const filterActiveGroupMarket = (eventClassifierId) => {
                return groupMarketsGTV.filter((group) => Number(group.eid) === (eventClassifierId));
            };

            if (events.length === 0 && parent) {
                events = parent.getChildren();
            }


            let activeGroupMarket = filterActiveGroupMarket(activeEventClassifierId);

            if (activeGroupMarket.length === 0 && parent) {
                activeGroupMarket = filterActiveGroupMarket(parent.eventClassifierId);
            }

            const marketTypes = [];
            activeGroupMarket.forEach((activeGroup) => {

                activeGroup.mt.forEach((activeMarketType) => {
                    marketTypes.push({
                        marketTypeTitle: resources_en.groupTitles[activeMarketType],
                        marketTypeId: activeMarketType,
                        showGroupedMarkets: true
                    });
                });
            });

            return marketTypes;
        }
    }

    render() {
        const allMarketsStyle = { "display": "block" };
        const className = this.state.isBodyVisible ? "expanded widgetHeader" : "collapsed widgetHeader";
        const bodyVisibleStyle = this.state.isBodyVisible ? {} : { "display": "none" };
        const sharedClass = this.props.isSharedSpace ? "shared" : "";
        const currentEventClassifier = this.state.currentEventClassifier;
        const allMarketsLink = "/" + configurationSettings.tab;
        const isVirtual = currentEventClassifier && currentEventClassifier.eventClassifierName.toLocaleLowerCase().indexOf("virtual") !== -1 ? true : false;
        const rootOnly = this.props.rootOnly || this.state.isVirtual;
        const allSportsTitle = GBEglobal.mode === ModeTypes.Multiples ? GBEglobal.resources.AllSportsMultiples : GBEglobal.resources.AllSports;

        const lookupId = currentEventClassifier ? currentEventClassifier.eventClassifierId : 0;
        let allEvents = GBEglobal.todaysEvents && GBEglobal.todaysEvents[lookupId] ? GBEglobal.todaysEvents[lookupId] : [];

        function getClasses(thisEvent) {
            var ev = thisEvent || {};

            return "sport_icon generic _" + ev.eventClassifierId;
        }

        var parts = window.location.hash.split("=");
        //var todaysEvents = [];
        var showChildEvents = true;


        switch (parts[0]) {
            case "#filter":

                var filterParts = parts[1].split("-");

                allEvents = [GBEglobal.todaysEvents[filterParts[0]][filterParts[1]]];
                showChildEvents = false;
                //todaysEvents = allEvents[0].orderedEvents || this.state.todaysEvents;

                break;
        }

        //allEvents = allEvents.filter(function (item) {
        //    return item.orderedEvents && item.orderedEvents.length > 0;
        //});

        return (
            <ErrorBoundary componentName="Leftnav">
                <div ref={this.thisComponentRef} className={sharedClass + " leftNav widget"}>
                    <span className={className} onClick={this.handleHeaderClick.bind(this)}><i className="arrow" />{allSportsTitle ?? "Sports"}</span>
                    <div className="gep-leftNav" style={bodyVisibleStyle}>
                        {currentEventClassifier !== null && !isVirtual &&
                            <Link className="btn btn-default allMarketsLink" to={allMarketsLink} onClick={this.handleEventClick.bind(this, null)} style={allMarketsStyle}>{allSportsTitle ?? "All Sports"}</Link>
                        }
                        {!rootOnly &&
                            <div>
                                {this.renderParentEvents(currentEventClassifier)}

                                {this.renderCurrentEvent(currentEventClassifier)}

                                {allEvents.map((link, index) => {
                                    return <a key={index} className="btn btn-default" href={"#filter=" + link.eventClassifierId + "-" + index}>{link.title}</a>;
                                })
                                }
                                {showChildEvents &&
                                    <>
                                        {this.renderChildrenEvents(currentEventClassifier)}
                                    </>
                                }

                                {!showChildEvents && this.state.todaysEvents.map((eventClassifier, index) => {

                                    return (<Link className="btn btn-default top a" key={index} to={GBEglobal.getEventClassifierPath(eventClassifier.eventClassifierId) + window.location.hash} >
                                        <i className={getClasses(eventClassifier)}>sports_soccer</i> {eventClassifier.eventClassifierName}
                                    </Link>);
                                })
                                }

                            </div>
                        }
                        {
                            rootOnly &&
                            <div>
                                {this.renderChildrenEvents(null)}
                            </div>
                        }
                    </div>
                </div>
            </ErrorBoundary>
        );
    }
}

export { Leftnav };